(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    // central protocol directive to show user protocols
    module.directive('ringfoonProtocol', ['$sce', 'ProtocolBroadcast', RingfoonProtocolDirectiveFn]);

    function RingfoonProtocolDirectiveFn($sce, ProtocolBroadcast) {
        var directive = {
            link: link,
            templateUrl: '/app/ringfoon/templates/ringfoon-protocol.template.html',
            restrict: 'E',
            scope: true // need own scope
        };
        return directive;

        function link(scope, element) {

            // modal element
            var modal = angular.element('#protocol-modal');
            var options = { backdrop: "true" };

            // list of protocols to show
            scope.protocols = [];

            // listen on broadcast event to open protocols
            var listener = scope.$on(ProtocolBroadcast.Show, function (event, protocol) {

                // avoid adding the same protocol twice (e.g. broadcast fired again before the modal's hide event resets the list)
                var alreadyShown = scope.protocols.some(function (existingProtocol) {
                    return existingProtocol.id === protocol.id;
                });

                if (!alreadyShown) {
                    scope.protocols.push(protocol);
                }

                // open modal
                modal.modal(options);
            });

            // trust as html
            scope.trustAsHtml = function (dom) {
                return $sce.trustAsHtml(dom); // cannot use ng-bind-html -> removes inline-styles
            };

            // listen on hide event
            modal.on("hide.bs.modal", function (event) {
                scope.protocols = [];
            });


            // on destroy
            scope.$on("$destroy", function () {
                listener();
                listener = null;
                modal.off("hide.bs.modal");
            });

        }
    }

})();